import React, { memo, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  createVolume,
  getVolumes,
  getVolumesData,
  getVolumesLoading,
} from '../../entity/volumes/Volumes'
import { shallowEqual } from 'react-redux'
import HeroComponent from '../../components/HeroComponent/HeroComponent'
import Sidebar from '../../Pages/Volumes/components/Sidebar'
import { FiPlusCircle } from 'react-icons/fi'
import CreateVolumeModal from '../CreateVolumeModal/CreateVolumeModal'
import { getUserData } from '../../entity/user/model/selector/getUserData/getUserData'

const VolumesLayout = ({ children }) => {
  const dispatch = useDispatch()
  const volumesData = useSelector(getVolumesData, shallowEqual)
  const volumesLoading = useSelector(getVolumesLoading, shallowEqual)
  const user = useSelector(getUserData, shallowEqual)

  const [createModalOpen, setCreateModalOpen] = useState(false)

  const modalHandler = () => {
    setCreateModalOpen(prev => !prev)
  }

  const createVolumeHnalder = async data => {
    await dispatch(createVolume(data))
    dispatch(getVolumes())
    modalHandler()
  }

  useEffect(() => {
    dispatch(getVolumes())
  }, [dispatch])

  if (volumesLoading && !volumesData) {
    return (
      <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
        <div className='mx-auto w-full spinner-border text-primary' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
    )
  }

  if (!volumesData) {
    return (
      <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
        <div className='mx-auto w-full spinner-border text-primary' role='status'>
          <span className='sr-only'>There is no Issue yet...</span>
        </div>
      </div>
    )
  }

  return (
    <>
      <HeroComponent />
      <div className='homepage-container max-w-4xl mx-auto'>
        {user?.role === 'admin' && (
          <FiPlusCircle
            className='mt-4 text-4xl hover:scale-110 transition-all cursor-pointer text-[#326383]'
            onClick={modalHandler}
          />
        )}
        <div className='w-full flex flex-row mx-auto my-4 relative'>
          {volumesData?.length > 0 && <Sidebar volumesData={volumesData} />}
          <div className='w-full px-4 min-h-64 max-w-lg break-words mx-auto'>{children}</div>
        </div>
      </div>
      {createModalOpen && (
        <CreateVolumeModal
          isOpen={createModalOpen}
          onClose={modalHandler}
          onSubmit={createVolumeHnalder}
        />
      )}
    </>
  )
}

export default memo(VolumesLayout)
